module.exports = __webpack_public_path__ + "static/img/login-logo.4253705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/login-logo.png
// module id = i+Md
// module chunks = 0